module.exports = __webpack_public_path__ + "img/OBCINA DOBREPOLJE.dd9976af.png";